import Pusher from 'pusher-js'

export default ({ app }, inject) => {
    const pusher_app_key = app.$config.PUSHER_APP_KEY;
    
    if (pusher_app_key) {
        const pusher = new Pusher(pusher_app_key, {
            cluster: 'us2'
        });

        inject('pusher', pusher)
    }
}
